import React from "react";
import { PLATFORM_VARIABLES } from "../../../cores/platformAutomations/types";

type Props = {
  onInsert: (token: string) => void;
};

export default function PlatformVariableChips({ onInsert }: Props) {
  return (
    <div className="pa-var-chips">
      <span className="pa-var-chips__label">Variables:</span>
      {PLATFORM_VARIABLES.map((variable) => (
        <button
          key={variable}
          type="button"
          className="pa-var-chips__chip"
          onClick={() => onInsert(`{{${variable}}}`)}
        >
          {`{{${variable}}}`}
        </button>
      ))}
    </div>
  );
}
